import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Thumbnail from '../../Thumbnail';
import { ImageUrl } from '../../../utils/constants';
import {  NewChampionsCard, NewVideoPlayer, EventCard, NewContentV2, CircleV2, CircleContainerV2 } from '../RecommendEventVideos/styles';
import { withTranslation } from 'react-i18next';
import { WatchedCircleSVG, ViewEventIcon } from '../../../utils/icons';

class OnDemandCards extends Component {
  constructor() {
    super();
    this.state = {
      showVideoModal: false
    }
  }

  videoModal =() => {
    const { history, video } = this.props;
    history.push(`/events/on-demand/${video.category_name}/${video.id}`)
  }

  render() {
    const { video, grid, onHover, onEnterMouse, onLeaveMouse, length, t } = this.props;
    const cardLength = length + 1;
    return (
      <NewChampionsCard grid={grid} margin={(cardLength) % 3 == 0 ? "0px" : "25px"}>
        <EventCard videoCSS={grid} onMouseEnter={() => onEnterMouse(video.id)} onMouseLeave={() => onLeaveMouse()}>
          <NewVideoPlayer>
            <Thumbnail
              src={`${ImageUrl}/${video.thumbnail_image}`}
              alt={video.title}
            />
          </NewVideoPlayer>
          {onHover === video.id &&
          <div className='educateImageBackground' onClick={() => this.videoModal()}>
            <div className="getStarted">
              {/* <img src={ImageUrl+"/event-section/rocket.svg"}/> */}
              {ViewEventIcon()}
              {t("View Event")} 
            </div>
          </div>
          }
          <NewContentV2 newPadding={'newPadding'}>
            <div className='firstContainer'>
              <div className='name'>
                {t(video.title)}
              </div>
            </div>
            <CircleContainerV2 marginRight={1}>
              <CircleV2 checked={Boolean(video.view_status)}>
                {Boolean(video.view_status) && <WatchedCircleSVG />}
              </CircleV2>
              <div className="quiz">
                {t("Watched")}
              </div>
            </CircleContainerV2>
          </NewContentV2>
        </EventCard>
      </NewChampionsCard>
    );
  }
}
OnDemandCards.propTypes = {
  video: PropTypes.object,  
  grid: PropTypes.number,
  onHover: PropTypes.number,
  onEnterMouse: PropTypes.func.isRequired,
  onLeaveMouse: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  length: PropTypes.number,
  t: PropTypes.func
};

export default (withTranslation()(OnDemandCards));
